import React from 'react'
import { connect } from 'react-redux'
import formatPhoneUS from './helpers/formatPhoneUS'
import Spinner from './Spinner'
import { buildPages } from './helpers/buildPaginationPages'

class AutoPilotUnsubscribe extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            unsubscribedUsers: [],
            currentPage: 1,
            itemsPerPage: 10,
            totalPages: 0,
            totalItems: 0,
            searchTerm: '',
            unsubscribeNumber: '',
            loading: false,
            showSpinner: false,
            spinnerState: 'sync',
            spinnerText: '',
            business: this.props.state.business,
        };

        this.getUnsubscribedUsers = this.getUnsubscribedUsers.bind(this);
        this.searchTimeout = null;
    }

    async getUnsubscribedUsers(page = this.state.currentPage, perPage = this.state.itemsPerPage, search = this.state.searchTerm) {
        this.setState({ loading: true });
        try {
            const { business } = this.state;
            const params = new URLSearchParams({ per_page: perPage, page });
            if (search) {
                params.set('search', search.replace(/\D/g, ''));
            }
            const url = `/business/${business.business_id}/autopilot/unsubscribed?${params}`;
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const r = await response.json();
            this.setState({
                unsubscribedUsers: r.data,
                currentPage: r.meta.current_page,
                itemsPerPage: r.meta.per_page,
                totalPages: r.meta.last_page,
                totalItems: r.meta.total,
                loading: false,
            });
            return r;
        } catch (error) {
            console.error("Error fetching unsubscribed users: ", error);
            this.setState({ loading: false });
            throw error;
        }
    }

    componentDidMount() {
        this.getUnsubscribedUsers();
    }

    render() {
        const { currentPage, totalPages, totalItems, itemsPerPage, unsubscribedUsers, loading } = this.state;

        const from = totalItems > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0;
        const to = Math.min(currentPage * itemsPerPage, totalItems);

        const handlePageChange = (pageNumber) => {
            this.setState({ currentPage: pageNumber }, () => this.getUnsubscribedUsers(pageNumber));
        };

        const handlePerPageChange = (e) => {
            const newPerPage = parseInt(e.target.value);
            this.setState({ itemsPerPage: newPerPage, currentPage: 1 }, () => {
                this.getUnsubscribedUsers(1, newPerPage);
            });
        };

        const handleSearchChange = (event) => {
            const value = event.target.value;
            this.setState({ searchTerm: value });

            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.setState({ currentPage: 1 }, () => {
                    this.getUnsubscribedUsers(1, this.state.itemsPerPage, value);
                });
            }, 400);
        };

        const handleNewPhoneUnsubscribe = (event) => {
            this.setState({ unsubscribeNumber: event.target.value });
        };

        const handleUnsubscribeSubmit = async (event) => {
            event.preventDefault();
            startSpinner();

            const payload = {
                phone: "+1" + this.state.unsubscribeNumber.replace(/\D/g, ''),
                _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            };

            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': payload._token
                },
                body: JSON.stringify(payload)
            };

            try {
                const response = await fetch('/business/' + this.state.business.business_id + '/autopilot/unsubscribe', options);

                if (response.ok) {
                    stopSpinner();
                    this.setState({ unsubscribeNumber: '' });
                    await this.getUnsubscribedUsers(1);
                } else if (response.status === 404) {
                    stopSpinner('User not found', 'error');
                } else {
                    stopSpinner('Error unsubscribing user...', 'error');
                }
            } catch (error) {
                console.error(error);
                stopSpinner('Error unsubscribing user...', 'error');
            }
        };

        const startSpinner = () => {
            this.setState({
                showSpinner: true,
                spinnerState: 'sync',
                spinnerText: __('Unsubscribing...'),
            });
        };

        const stopSpinner = (customMessage, state = 'success') => {
            this.setState({
                spinnerState: state,
                spinnerText: customMessage ? customMessage : __('Successfully Unsubscribed!')
            });
            setTimeout(() => {
                this.setState({
                    showSpinner: false,
                    spinnerState: 'sync',
                    spinnerText: ''
                });
            }, 3000);
        };

        const formatDate = (dateString) => {
            if (!dateString) return '';
            const d = new Date(dateString);
            return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        };

        return (
            <div className="edit-vin w-100 right-side-content unsubscribe-page">
                <div className="w-100 border-bottom d-flex align-items-center bg-white p-2 py-3 shadow-sm">
                    <div className="d-flex ml-4 mr-auto">
                        <a className="btn btn-outline-primary text-nowrap mr-2"
                           href={window.location.pathname.replace(/\/unsubscribe$/, '/manual')}>{__('Back to Send Rating Request')}
                        </a>
                    </div>
                </div>

                <div className="w-100 p-4">
                    {/* Manually unsubscribe section */}
                    <div className="card mb-4">
                        <div className="card-body">
                            <h5 className="card-title mb-3">{__('Manually Unsubscribe a User')}</h5>
                            <div className="d-flex align-items-end">
                                <div className="mr-3" style={{ maxWidth: 280 }}>
                                    <label htmlFor="manually-unsubscribe-user" className="small text-muted mb-1">
                                        {__('Phone Number')}
                                    </label>
                                    <input
                                        id="manually-unsubscribe-user"
                                        type="tel"
                                        className="form-control"
                                        maxLength={14}
                                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                        placeholder="555-555-5555"
                                        value={formatPhoneUS(this.state.unsubscribeNumber || '')}
                                        onChange={(e) => handleNewPhoneUnsubscribe(e)}
                                        onKeyDown={(event) => {
                                            if (
                                                !/[0-9+]/.test(event.key) &&
                                                !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(event.key) &&
                                                !event.ctrlKey && !event.metaKey
                                            ) {
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleUnsubscribeSubmit}
                                    disabled={this.state.unsubscribeNumber.replace(/\D/g, '').length < 10}
                                >
                                    {__('Unsubscribe Now')}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Unsubscribed users list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="mb-0">{__('Unsubscribed Users')}</h5>
                            <div style={{ maxWidth: 240 }}>
                                <input
                                    type="tel"
                                    placeholder={__('Search by phone...')}
                                    className="form-control form-control-sm"
                                    maxLength={14}
                                    value={formatPhoneUS(this.state.searchTerm || '')}
                                    onChange={handleSearchChange}
                                    onKeyDown={(event) => {
                                        if (
                                            !/[0-9]/.test(event.key) &&
                                            !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(event.key) &&
                                            !event.ctrlKey && !event.metaKey
                                        ) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className="card-body p-0" style={{ position: 'relative', minHeight: 100 }}>
                            {loading && (
                                <div className="d-flex justify-content-center align-items-center py-4"
                                     style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.7)', zIndex: 1 }}>
                                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                                        <span className="sr-only">{__('Loading...')}</span>
                                    </div>
                                </div>
                            )}

                            {!loading && unsubscribedUsers.length === 0 ? (
                                <div className="text-center text-muted py-5">
                                    {this.state.searchTerm
                                        ? __('No users found matching your search.')
                                        : __('No unsubscribed users yet.')}
                                </div>
                            ) : (
                                <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>{__('Name')}</th>
                                            <th>{__('Phone')}</th>
                                            <th>{__('Unsubscribed')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {unsubscribedUsers.map((user) => (
                                            <tr key={user.id}>
                                                <td>{user.full_name || `${user.first_name || ''} ${user.last_name || ''}`.trim() || '-'}</td>
                                                <td>{user.phones?.[0]?.phone ? formatPhoneUS(user.phones[0].phone) : '-'}</td>
                                                <td>{formatDate(user.unsubscribed_at)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                </div>
                            )}
                        </div>

                        {/* Pagination footer */}
                        <div className="card-footer d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <span className="text-muted small mr-3">
                                    {totalItems > 0
                                        ? `${__('Showing')} ${from}-${to} ${__('of')} ${totalItems}`
                                        : `0 ${__('results')}`}
                                </span>
                                <select
                                    value={itemsPerPage}
                                    onChange={handlePerPageChange}
                                    className="form-control form-control-sm d-inline-block"
                                    style={{ width: 70 }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                                <span className="text-muted small ml-2">{__('per page')}</span>
                            </div>

                            {totalPages > 1 && (
                                <nav>
                                    <ul className="pagination pagination-sm mb-0">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}
                                                    disabled={currentPage === 1}>
                                                &lsaquo;
                                            </button>
                                        </li>

                                        {buildPages(currentPage, totalPages, 2, 1).map((p, idx) =>
                                            p === '…' ? (
                                                <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                    <span className="page-link">…</span>
                                                </li>
                                            ) : (
                                                <li key={p} className={`page-item ${currentPage === p ? 'active' : ''}`}>
                                                    <button className="page-link" onClick={() => handlePageChange(p)}>
                                                        {p}
                                                    </button>
                                                </li>
                                            )
                                        )}

                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}
                                                    disabled={currentPage === totalPages}>
                                                &rsaquo;
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}
                        </div>
                    </div>
                </div>

                {this.state.showSpinner &&
                    <Spinner spinnerState={this.state.spinnerState} spinnerText={this.state.spinnerText}/>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        business: state.business
    }
}

export default connect(mapStateToProps)(AutoPilotUnsubscribe)
